import { render, staticRenderFns } from "./TheColumnDrawer.vue?vue&type=template&id=2891ac94&"
import script from "./TheColumnDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheColumnDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports